import { createFileRoute } from '@tanstack/react-router';
import { SiteDetailPage, type SiteTab } from '@/features/workforce/sites/SiteDetail';

const TABS: readonly SiteTab[] = ['anagrafica', 'orari', 'condivisione'];

export const Route = createFileRoute('/_app/organization/sites/$siteId')({
  component: SiteDetail,
  /* `?tab=orari`: dall'elenco, una sede «Senza orari» si apre dove si rimedia. */
  validateSearch: (s: Record<string, unknown>): { tab?: SiteTab } =>
    (TABS.includes(s.tab as SiteTab) ? { tab: s.tab as SiteTab } : {}),
});

/** `/organization/sites/:siteId` — anagrafica, orari dei turni e condivisione della sede. */
function SiteDetail() {
  const { siteId } = Route.useParams();
  const { tab } = Route.useSearch();
  return <SiteDetailPage siteId={siteId} initialTab={tab} />;
}
